import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";
import { useParams } from "react-router-dom";
import { getUserById, getUserByRef } from "../../models/UserFunctions.js";
import {
  getOrgById,
  getOrgByRef,
  transformAdminPaymentsToTable,
} from "../../models/OrgFunctions.js";

import Space from "../../layout/Space.js";

import PrimaryButton from "../../buttons/PrimaryButton.js";
import { useSnackbar } from "notistack";

import { useAppContext } from "../../config/AppContext.js";
import createNewMember from "../../api/create/createNewMember.js";
import {
  getRefFromId,
  listenCollection,
  queryCollection,
  updateDocDataField,
} from "../../models/DataFunctions.js";

import DataGridFull from "../../tables/DataGridFull.js";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import SearchBarInvoices from "../../textfields/SearchBarInvoices.js";
import SearchBarPayments from "../../textfields/SearchBarPayments.js";
import initiatePayment from "../../api/folder/initiatePayment.js";
import moment from "moment";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";
import PaymentsTabs from "../../tabs/PayementsTabs.js";
import SmallSpinner from "../../loading/SmallSpinner.js";
import validatePaymentManually from "../../api/stripe/validatePaymentManually.js";
import DataGridGPT2 from "../../tables/DataGridGPT2.js";
import TabGPT from "../../tabs/TabGPT.js";

const PaymentManagerAdmin = ({ navigateWorkspace }) => {
  const { currentUser, loading } = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  const [orgData, setOrgData] = useState({});
  const [userData, setUserData] = useState(null);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [payments, setPayments] = useState([]);
  const [rows, setRows] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [columns, setColumns] = useState([]);

  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);

  const [loadingData, setLoadingData] = useState(null);
  const [loadingSelection, setLoadingSelection] = useState("");
  const [tabs = [], setTabs] = useState([
    {
      id: "current",
      label: "Paiements en cours",
    },
    {
      id: "archived",
      label: "Paiements archivés",
    },
  ]);
  const [activetab, setActivetab] = useState("current");

  const handleSelectionModelChange = (selectionModel) => {
    setSelectionModel(selectionModel);
  };

  const handleArchiveSelection = async (inverse = false) => {
    setLoadingSelection("archive");
    if (selectionModel.length > 0) {
      for (const id of selectionModel) {
        const payment_ref = getRefFromId("payment", id);
        let state = inverse ? "pending" : "archived";
        await updateDocDataFieldApi(payment_ref, "tab", state, prefix);
      }
    }
    setSelectionModel([]);
    setLoadingSelection("");
  };

  const tabContent = [<span></span>, <span></span>, <span></span>];

  const [tabindex, setTabIndex] = useState(0);
  const [selectionModel, setSelectionModel] = useState([]);

  // Fonction pour afficher les messages Snackbar
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  // Fonction pour récupérer les données de l'organisation
  const handleFetchData = async () => {
    if (currentUser) {
      try {
        const user = await getUserById(currentUser.uid); // Récupère l'utilisateur par ID
        const org = await getOrgById(user.org_id); // Récupère l'organisation par référence

        const filters = [];

        const payments = await queryCollection("payment", filters); // Récupère les paiements
        const options = payments.map((payment) => ({
          value: payment.id,
          label: payment.nom || "",
        }));
        setPayments(payments);
        setOptions(options);

        setOrgData(org);
        setUserData(user);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de l'organisation:",
          error
        );
      }
    }
  };

  const CancelPayment = async (e, ref) => {
    e.stopPropagation();
    await updateDocDataFieldApi(ref, "state", "error", prefix);
    handleClickVariant("Paiement annulé", "success");
  };

  const ValidatePayment = async (e, value) => {
    setLoadingData(value);
    e.stopPropagation();
    const token = await getOrRefreshFirebaseToken(); // Fetch Firebase token
    await validatePaymentManually(value, token, prefix);

    handleClickVariant("Paiement validé", "success");
    await handleFetchData();
    setLoadingData(null);
  };

  const Archive = async (e, ref, inverse = false) => {
    e.stopPropagation();
    await updateDocDataFieldApi(
      ref,
      "admin_tab",
      inverse ? "unarchived" : "archived",
      prefix
    );
    handleClickVariant("Paiement archivé", "success");
  };

  const id = orgData.id;
  useEffect(() => {
    handleFetchData(); // Récupère les données de l'organisation lorsque le composant est monté
  }, [currentUser]);

  useEffect(() => {
    if (payments) {
      const { rows, columns } = transformAdminPaymentsToTable(
        payments,
        searchValue,
        activetab
      );
      setRows(rows);
      setColumns(columns);
    }
  }, [payments, searchValue, activetab]);

  if (loading || !currentUser) {
    return <div></div>; // Affiche un message de chargement
  }

  return (
    <div className="w-full h-full  flex flex-col items-start justify-start">
      {/* Première colonne */}
      <div className="flex flex-col w-full pl-4">
        <div className="text-hx font-medium text-left">Paiements</div>
        <Space y={10} />
        <div className="w-c600">
          {" "}
          <SearchBarPayments
            orgData={orgData}
            options={options}
            setValue={setSearchValue}
            value={searchValue}
            onAction={() => {}}
          />
        </div>

        {selectionModel && selectionModel.length > 0 && (
          <div className="flex flex-row gap-2 mt-4">
            {tabindex === 0 && (
              <PrimaryButton
                onClick={() => handleArchiveSelection(false)}
                disabled={loadingSelection == "archive"}
              >
                Archiver la sélection{" "}
                <SmallSpinner loading={loadingSelection == "archive"} />
              </PrimaryButton>
            )}
            {tabindex === 1 && (
              <PrimaryButton
                onClick={() => handleArchiveSelection(true)}
                disabled={loadingSelection == "archive"}
              >
                Désarchiver la sélection{" "}
                <SmallSpinner loading={loadingSelection == "archive"} />
              </PrimaryButton>
            )}
          </div>
        )}
        <Space y={10} />
        {searchValue === "" && (
          <div className="flex flex-row gap-2">
            <div className="ml-0 pl-0 left-0 relative">
              <TabGPT
                tabs={tabs}
                activeTab={activetab}
                setActiveTab={(tab) => {
                  setActivetab(tab);
                }}
              />
            </div>{" "}
          </div>
        )}

        <Space y={10} />
        <div className="w-full max-w-c1p4k ">
          <div className="  ">
            <DataGridGPT2
              selectable={false}
              rows={rows}
              columns={columns}
              onClick={() => {}}
              initial_sort_field="last_updated"
              initial_asc="desc"
              handleSelectionModelChange={handleSelectionModelChange}
              initial_saved_columns_showed={{
                id: true,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default PaymentManagerAdmin;
